import React, { useEffect, useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Button,
  Container,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import TravelLinkService from "../../../../../services/TravelLinkService/TravelLinkService";
import "./Testimonial.css";
import ReadMoreModal from "./ReadMoreModal";
import { Link } from "react-router-dom";
import avatarDummy from "../../../../../assets/images/users/user-dummy-img.jpg"

const TestimonialCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [groupedTestimonials, setGroupedTestimonials] = useState([]);
  const [itemsPerSlide, setItemsPerSlide] = useState(3);
  const [showModal, setShowModal] = useState(false); // To manage modal visibility
  const [modalTestimonial, setModalTestimonial] = useState(null); // Store selected testimonial for modal

  // Adjust items per slide based on screen width
  useEffect(() => {
    const updateItemsPerSlide = () => {
      setItemsPerSlide(window.innerWidth < 768 ? 1 : 3);
    };
    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);
    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === groupedTestimonials.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? groupedTestimonials.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const fetchData = async () => {
    try {
      const response = await TravelLinkService.getAllTestimonial();
      const grouped = [];
      for (let i = 0; i < response.length; i += itemsPerSlide) {
        grouped.push(response.slice(i, i + itemsPerSlide));
      }
      setGroupedTestimonials(grouped);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [itemsPerSlide]);

  const openModal = (testimonial) => {
    setModalTestimonial(testimonial); // Set the testimonial to show in modal
    setShowModal(true); // Show the modal
  };

  const closeModal = () => {
    setShowModal(false); // Hide the modal
    setModalTestimonial(null); // Clear the selected testimonial
  };

  const slides = groupedTestimonials.map((testimonialGroup, index) => (
    <CarouselItem
    key={index}
    onExiting={() => setAnimating(true)}
    onExited={() => setAnimating(false)}
    className="w-100 h-100"
  >
    <Row>
      {testimonialGroup.map((testimonial, idx) => (
        <Col
          xs="12"
          md={itemsPerSlide === 1 ? "12" : "4"}
          key={idx}
          className="d-flex justify-content-center"
        >
          <Card
            className="mb-4 w-100 d-flex flex-column"
            style={{
              borderRadius: "20px",
              borderRight: "10px solid #0E9EDA",
              minHeight: "220px", // Ensures all cards have the same height
              maxHeight: "220px",
            }}
          >
            <CardBody className="d-flex flex-column justify-content-between">
              <CardTitle className="mb-2 fw-medium">
                “{testimonial.title}”
              </CardTitle>
              <CardText className="fs-12 flex-grow-1">
                {testimonial.description.length > 100
                  ? `${testimonial.description.substring(0, 100)}...`
                  : testimonial.description}
              </CardText>
              <h6
                className="link text-end mb-2 p-0 fs-12"
                onClick={() => openModal(testimonial)}
                style={{ cursor: "pointer", color: "#0E9EDA" }}
              >
                Read More
              </h6>
              <div className="d-flex align-items-center">
                <img
                  src={testimonial.profile_image_url || avatarDummy}
                  className="rounded-circle avatar-md"
                  style={{ width: "50px", height: "50px" }}
                  alt={`${testimonial.name}'s profile`}
                />
                <div className="ms-3">
                  <h6 className="mb-1">{testimonial.name}</h6>
                  <small className="text-muted">{testimonial.country}</small>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  </CarouselItem>
  
  ));

  return (
    <div className="p-0 m-0 mb-5">
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        ride="carousel"
        interval={3000}
      >
        <CarouselIndicators
          items={groupedTestimonials}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
          className="custom-carousel-control prev-control"
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
          className="custom-carousel-control next-control"
        />
      </Carousel>
      <div className="text-center">
        <Link  className="link" to="/testimonials">
          View All Testimonials
        </Link>
      </div>

      <ReadMoreModal
        showModal={showModal} // Correct visibility state
        modalTestimonial={modalTestimonial} // Selected testimonial
        closeModal={closeModal} // Close modal handler
      />
    </div>
  );
};

export default TestimonialCarousel;
